module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="joinos-hook"></div>\n\n<div class="contact-hook"></div>\n\n<button type="submit" class="button button-send">Send</button>\n<a class="button button-secondary button-close">Abandon</a>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./messaging/templates/layout.html
// module id = 287
// module chunks = 0